import { takeEvery } from 'redux-saga/effects';
import { SurveyApi } from 'api';
import * as actions from './actions';
import { sagasHandlersFactory } from '../utils';

const handleGetSurveyByEmailRequest = sagasHandlersFactory.createGetOneRequestHandler({
  actions: actions.getSurveyByEmail,
  request: SurveyApi.getSurveyByEmail,
  requestArgsBuilder: (action) => {
    const { params } = action.payload;
    return {
      params,
    };
  },
  transformResponse: (response, action) => ({
    ...response,
    id: action.payload.params.token,
  }),
});

const handleGetSurveysRequest = sagasHandlersFactory.createGetManyRequestHandler({
  actions: actions.getSurveys,
  request: SurveyApi.getSurveys,
  requestArgsBuilder: (action) => {
    const { userId } = action.payload.params;
    return [userId];
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  transformResponse: (response) => response.results,
});

const handleUpdateSurveyRequest = sagasHandlersFactory.createUpdateOneRequestHandler({
  actions: actions.updateSurvey,
  request: SurveyApi.updateSurvey,
  requestArgsBuilder: (action) => {
    const { id, params, entity } = action.payload;
    const { userId } = params;
    return [
      id,
      userId,
      {
        body: entity,
      },
    ];
  },
});

const handleUpdateSurveyByEmailRequest = sagasHandlersFactory.createUpdateOneRequestHandler({
  actions: actions.updateSurveyByEmail,
  request: SurveyApi.updateSurveyByEmail,
  requestArgsBuilder: (action) => {
    const { params, entity } = action.payload;
    return {
      params,
      body: entity,
    };
  },
  transformResponse: (response, action) => ({
    ...response,
    id: action.payload.params.token,
  }),
});

export default function* adminOrdersSagas() {
  yield takeEvery(actions.getSurveyByEmail.request.type, handleGetSurveyByEmailRequest);
  yield takeEvery(actions.updateSurveyByEmail.request.type, handleUpdateSurveyByEmailRequest);
  yield takeEvery(actions.getSurveys.request.type, handleGetSurveysRequest);
  yield takeEvery(actions.updateSurvey.request.type, handleUpdateSurveyRequest);
}
